import { getUser } from "@/services/user";

const state = {
  user: {},
  haveUser: false
};

const mutations = {
  CLEAR_USER(state) {
    state.user = {};
    state.haveUser = false;
  },
  SET_USER(state, value) {
    state.user = value;
    state.haveUser = true;
  }
};

const getters = {
  getUser: state => {
    return state.user;
  },
  haveUser: state => {
    return state.haveUser;
  },
  isAdmin: state => {
    return state.user.admin == true;
  }
};

const actions = {
  fetchUser({ commit }, uid) {
    commit("CLEAR_USER");
    getUser(uid).then(data => commit("SET_USER", data));
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
